import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import calendarPng from '@/ui/assets/calendar.png';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton.tsx';
import { translate } from '@/ui/i18n';

export function EndTrial() {
  const navigate = useNavigate();

  const onClickGoPrenium = async () => {
    navigate('/app/contact');
  };
  return (
    <Stack gap="24px" alignItems="center" justifyContent="center">
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        {translate('License.EndTrial.title')}
      </Typography>
      <img src={calendarPng} alt={translate('License.EndTrial.title')} />

      <Typography
        sx={{
          fontSize: '40px',
          fontWeight: 800,
          lineHeight: '48px',
          letterSpacing: '0.4px',
        }}
      >
        {translate('License.EndTrial.continue')}
      </Typography>

      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 400,
        }}
      >
        {translate('License.EndTrial.description')}
      </Typography>
      <FSPrimaryButton onClick={onClickGoPrenium}>
        {translate('License.EndTrial.button')}
      </FSPrimaryButton>
    </Stack>
  );
}
